import { atom } from "recoil"

export const matchingOfferDraftRequestIdState = atom({
  key: "atoms/matching/matchingOfferDraftRequestIdState",
  default: 0,
})
